import { useCallback, useEffect, useState } from "react";
import { deleteUser, getInspectionUsersData, signUpInspectionUser, updateInspectionUser } from "../../APIS";

export const useInspectionUsersQuery = () => {
  const [inspectionUsers, setInspectionUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadUsers = useCallback(async (signal) => {
    setLoading(true);
    setError(null);
    try {
      const storedUser = sessionStorage.getItem("userDetails");
      const token = storedUser ? JSON.parse(storedUser)?.token : null;
      const data = await getInspectionUsersData(token, { signal });
      setInspectionUsers(data?.data || []);
    } catch (err) {
      if (err.name !== "AbortError") {
        setError(err);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    loadUsers(controller.signal);

    return () => {
      controller.abort();
    };
  }, [loadUsers]);

  const refetch = useCallback(() => {
    const controller = new AbortController();
    loadUsers(controller.signal);
    return () => controller.abort();
  }, [loadUsers]);

  return { inspectionUsers, loading, error, refetch };
};

export const useInspectionUserMutation = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createUser = async (userData) => {
    setLoading(true);
    setError(null);
    try {
      const storedUser = sessionStorage.getItem("userDetails");
      const token = storedUser ? JSON.parse(storedUser)?.token : null;
      const response = await signUpInspectionUser(userData, token);
      return response.data;
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const updateUser = async (userId, userData) => {
    setLoading(true);
    setError(null);
    try {
      const storedUser = sessionStorage.getItem("userDetails");
      const token = storedUser ? JSON.parse(storedUser)?.token : null;
      const response = await updateInspectionUser(userId, userData, token);
      return response.data;
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { createUser, updateUser, loading, error };
};


export const useDeleteInspectionUserMutation = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const deleteInspectionUser = async (userId) => {
    setLoading(true);
    setError(null);
    try {
      const storedUser = sessionStorage.getItem("userDetails");
      const token = storedUser ? JSON.parse(storedUser)?.token : null;
      const response = await deleteUser(userId,  token);
      return response.data;
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { deleteInspectionUser, loading, error };
};